import layerService from '@/api/layerService'
import { mapState, mapMutations } from 'vuex'
import { MODULE_NAME, MUTATIONS } from '@/store/map/constants'

export default {
  name: 'MapComponent',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      loading: true
    }
  },
  mounted () {
    this.createMap()
  },
  beforeDestroy () {
    this[MUTATIONS.RESET_VIEWSTATE]()
    layerService.destroy()
  },
  computed: {
    ...mapState(MODULE_NAME, ['viewState']),
    map () {
      return layerService.deckInstance
    },
    layers () {
      return layerService.layers
    }
  },
  methods: {
    ...mapMutations(MODULE_NAME, Object.values(MUTATIONS)),
    createMap () {
      if (layerService.deckInstance) {
        return
      }
      layerService.init({
        container: '#map',
        mapStyle: 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json',
        viewState: this.viewState,
        onViewStateChange: ({ viewState }) => {
          this[MUTATIONS.SET_VIEWSTATE](viewState)
        },
        onLoad: () => {
          this.loading = false
          this.$emit('loaded')
        }
      })
      window.deckMap = layerService.deckInstance
    }
  }
}
